import { ChevronDownIcon, ChevronUpDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import type { RowData } from '@tanstack/react-table';
import clsx from 'clsx';
import type { EdiColumn } from '@/libs/table';

interface ColumnHeaderProps<T extends RowData> {
  column: EdiColumn<T>;
  title: string;
  className?: string;
  enableSorting?: boolean;
}

export const ColumnHeader = <T extends RowData>({
  column,
  title,
  className = '',
  enableSorting = true,
}: ColumnHeaderProps<T>) => {
  const sortState = column.getIsSorted();
  const sortKey = sortState === false ? 'false' : sortState;

  return (
    <div
      className={clsx('flex items-center gap-1', enableSorting && 'cursor-pointer', className)}
      onClick={column.getToggleSortingHandler()}
    >
      <span>{title}</span>
      {enableSorting &&
        {
          asc: <ChevronUpIcon className="w-4" />,
          desc: <ChevronDownIcon className="w-4" />,
          false: <ChevronUpDownIcon className="w-4 text-neutral-600" />,
        }[sortKey]}
    </div>
  );
};
